import {Action} from '@ngrx/store';
import * as _ from 'lodash';
import {layoutActionTypes, SetLanguageAction} from '../actions/layout';
import {Preference} from '../models/preferences';
import {LoadPreferencesSuccessAction, preferencesActionTypes} from '../actions/preferences';
import {DEFAULT_PAGE_SIZE} from '../consts';

export interface LayoutState {
  sidebarClosed: boolean;
  language: string;
  preferences: Preference[];
}

const initialState: LayoutState = {
  sidebarClosed: true,
  language: undefined,
  preferences: null
};

export function layoutReducer(state: LayoutState = initialState, action: Action): LayoutState {
  switch (action.type) {
    case layoutActionTypes.TOGGLE_SIDEBAR:
      return {sidebarClosed: !state.sidebarClosed, language: state.language, preferences: state.preferences};
    case layoutActionTypes.SET_LANGUAGE:
      return handleSetLanguageAction(state, action);
    case preferencesActionTypes.LOAD_SUCCESS:
    case preferencesActionTypes.SET_SUCCESS:
      return handlePreferencesAction(state, action);
    default:
      return state;
  }
}

function handleSetLanguageAction(state: LayoutState, action: SetLanguageAction): LayoutState {
  return {sidebarClosed: state.sidebarClosed, language: action.payload, preferences: state.preferences};
}

function handlePreferencesAction(state: LayoutState, action: LoadPreferencesSuccessAction): LayoutState {
  return {sidebarClosed: state.sidebarClosed, language: state.language, preferences: action.payload};
}

export const layoutSelectors = {
  sidebarClosed: (state: LayoutState) => _.get(state, 'sidebarClosed', true),
  language: (state: LayoutState) => _.get(state, 'language'),
  preferences: (state: LayoutState) => _.get(state, 'preferences'),
  preferencesByName: (state: LayoutState, props: string) => {
    return state.preferences ? +state.preferences.filter(pref => pref.name === props).length ?
        +state.preferences.filter(pref => pref.name === props)[0].value : DEFAULT_PAGE_SIZE
      : DEFAULT_PAGE_SIZE
  }
};
